export const pathInfo = {
  home: '/home',
  position: '/position',
  social: '/social',
  campus: '/campus',
  sharePosition: '/share-position',
  questionSocial: '/question/social',
  questionCampus: '/question/campus',
  questionAnnouncement: '/question/announcement',
  beidou: '/beidou',
  qihang: '/qihang',
  workInMeituan: '/about/workInMeituan',
  ourTeam: '/about/ourTeam',
};
